import {validateObject, objectContainsError} from '../../../utils/ValidationUtils'

/*
    methods for form validation of Registration Wizard components
*/

export const validationDefinitions = {

    name: (value) => {
        if (value.length < 1) {
            return ['Pole Kontaktní osoba musí být vyplněné'];
        }
    },

    email : (value) => {
        if (!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            return ["Formát emailu není platný"];
        }
    },

    phone : (value) => {
        if (!value.match(/^[+]?[()/0-9. -]{9,}$/i)) {
            return ['Telefonní číslo není ve správném formátu'];
        }
    },

    number: (value) => {
        if (value.length < 1) {
            return ['Pole Předpokládaný počet poukazů musí být vyplněné'];
        }
    },

    company: (value) => {
        if (value.length < 1) {
            return ['Pole Název společnosti musí být vyplněné'];
        }
    },
    gdprChecked: (value) => {
        if( !value ) {
            return ['Je třeba potvrdit souhlas se zpracováním osobních údajů'];
        }
    }


//    question: (value) => {
//        if (value.length < 1) {
//            return ['Dotaz je příliš krátký, musí mít alespoň 1 znak'];
//        }
//    }

};

export function validateForm(state) {
    return Object.assign({}, state, validateObject(validationDefinitions, state));
}

/**
 * Check all nested objects for validation errors
 * @param state
 * @returns {boolean}
 */
export function isFormValid(state) {
    return !objectContainsError(state);
}






// WEBPACK FOOTER //
// ./src/components/company/askus/AskUsValidations.js